// extracted by mini-css-extract-plugin
export default {"container":"srBTzqmdm91ykAC0AUvY"};